import React from 'react';

export type UserAvatarSize = 'small' | 'medium' | 'large';

type UserAvatarProps = {
	imageUrl?: string;
	firstName?: string;
	size?: UserAvatarSize;
	bordered?: boolean;
	className?: string;
};

// small 1.5rem · medium 2rem (layoutSmall) · large 2.8rem — matches the sizes
// the RISE `UserAvatar` was used at across TopBar, account-settings, and Drawer.
const SIZE_CLASSES: Record<UserAvatarSize, string> = {
	small: 'h-[1.5rem] w-[1.5rem]',
	medium: 'h-layoutSmall w-layoutSmall',
	large: 'h-[2.8rem] w-[2.8rem]',
};

/**
 * Circular user avatar. Renders `imageUrl` as a cover background when provided;
 * otherwise falls back to the uppercase first initial on a primary background.
 * SDS/Tailwind replacement for RISE's `UserAvatar` from `@stashinvest/ui`.
 */
export function UserAvatar({
	imageUrl,
	firstName,
	size = 'medium',
	bordered = false,
	className = '',
}: UserAvatarProps) {
	const initial = !imageUrl && firstName ? firstName.slice(0, 1) : null;

	return (
		<div
			className={[
				'flex shrink-0 items-center justify-center overflow-hidden rounded-full',
				'bg-primary bg-cover bg-center uppercase text-onPrimary',
				SIZE_CLASSES[size],
				bordered ? 'border-2 border-primary' : '',
				className,
			]
				.filter(Boolean)
				.join(' ')}
			style={imageUrl ? { backgroundImage: `url("${imageUrl}")` } : undefined}
		>
			{initial}
		</div>
	);
}

export default UserAvatar;
